import { createContext } from 'react';

import { Site_site } from './gqlTypes/Site';

export interface ISiteContext extends Site_site {
  availableOfferFilters: string[];
}
export const SiteContext = createContext<ISiteContext>({} as ISiteContext);

SiteContext.displayName = 'SiteContext';
